<div *ngIf="visible" class="loader-overlay ashcorp-splash-loader" aria-busy="true" aria-label="Loading">
    <img src="assets/branding/ashcorp-logo.png" alt="Ashcorp">
    <div class="ashcorp-splash-loader__spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
</div>
